export class FindAllDashboards {
  public static readonly type = '[Project/Dashboard/List] FindAllDashboards';
}
